import React, {useContext } from 'react'

import styles from './DetailInput.module.css';
import {QuoteMasterContext} from 'Contexts/QuoteMasterContext.js';  

export default function DetailInput({width, inputElement, readOnly, backgroundReadOnly='var(--background-non-editable)', borderBottom=true}){
    const {currentServiceOrder} = useContext(QuoteMasterContext);

    const standardStyles = () => {
        if(readOnly===false){
            return {backgroundColor: 'var(--background-light)'}
        }
        const nonEditableInputStyles = {
            backgroundColor: backgroundReadOnly,
            pointerEvents: 'none',
            color: 'var(--letter-dark)',
            readOnly: readOnly
        };

        if(currentServiceOrder.currentStage!=='notInitiated'){
            return nonEditableInputStyles
        }
        if(currentServiceOrder.runType === 'standardTest'){
            return nonEditableInputStyles
        }
        if(readOnly){
            return nonEditableInputStyles
        }   
   
        return {}
    }

        
    return(
        <div 
            className={styles.detailInput} 
            style={{width: width, borderBottom: borderBottom ? '1px solid var(--border-dark)':'none', ...standardStyles()}} 
        >
            {inputElement}
        </div>
    )
}



